// 图片上传函数
import {createUploadImgName, deletImgObject, uploadImg} from "./uploadImage";
import {watchScroll} from "./pagination";

// 检测字符串与数组元素匹配的值
function findMatch(str, arr, flag) {
  let result = '';
  arr.forEach(item => {
    if(flag){
      if (str.indexOf(item.name) !== -1) {
        result = item;
        return;  // 如果找到匹配的元素，则直接返回
      }
    }else{
      if (str.indexOf(item) !== -1) {
        result = item;
        return;  // 如果找到匹配的元素，则直接返回
      }
    }
  });
  return result;
}

// 将unix格式时间戳转成可识别的字符串
function convertUnixTimestamp(unixTimestamp) {
  // 将UNIX时间戳转换为毫秒
  let timestamp = unixTimestamp * 1000;

  // 创建一个新的Date对象
  let date = new Date(timestamp);

  // 获取年、月、日、小时、分钟和秒
  let year = date.getFullYear();
  let month = String(date.getMonth() + 1).padStart(2, '0');
  let day = String(date.getDate()).padStart(2, '0');
  let hours = String(date.getHours()).padStart(2, '0');
  let minutes = String(date.getMinutes()).padStart(2, '0');
  let seconds = String(date.getSeconds()).padStart(2, '0');

  // 格式化日期字符串
  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
}

// 去除对象中的空字符串
function removeEmptyProperties(obj) {
  for (let key in obj) {
    if (obj[key].trim() === '') {
      delete obj[key];
    }
  }
  return obj;
}

export {
  uploadImg,
  createUploadImgName,
  deletImgObject,
  watchScroll,
  findMatch,             // 检测字符串与数组元素匹配的值
  convertUnixTimestamp,
  removeEmptyProperties
}



// WEBPACK FOOTER //
// ./src/util/index.js